export default {
  setChannelData(state, data) {
    state.channelData = data;
  },
};
